const sw = new Worker('/sw.js');

export default {
  parse: data => (
    new Promise((resolve) => {
      sw.onmessage = (res) => { resolve(res); };
      sw.postMessage(data);
    })
  ),
};
